module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"mime_type_not_supported":"不支援此檔案類型"},"en":{"mime_type_not_supported":"Unsupported file type"}}')
  delete Component.options._Ctor
}
